import { useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useEditorRef } from 'platejs/react';
import { toast } from 'react-toastify';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import toolbarStyles from '../PlateToolbar/PlateToolbar.module.scss';
import { handleImageInsert } from '../../components/ImagePlugin/handleImageInsert';
import { usePlateEditorConfig } from '../../PlateEditorConfigContext';

const ACCEPT = 'image/png,image/jpeg,image/gif,image/webp,image/svg+xml';

export function ImageButton() {
    const editor = useEditorRef();
    const { uploadSource } = usePlateEditorConfig();
    const inputRef = useRef<HTMLInputElement>(null);

    const onClick = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        inputRef.current?.click();
    }, []);

    const onFile = useCallback(
        async (e: React.ChangeEvent<HTMLInputElement>) => {
            const file = e.target.files?.[0];
            // Reset so picking the same file twice still fires onChange.
            if (e.target) e.target.value = '';
            if (!file) return;
            const result = await handleImageInsert(file, editor, uploadSource);
            if (result.error === 'invalid-mime') toast.error('Invalid image file');
            else if (result.error === 'too-large') toast.error('Image too large (max 8 MB)');
        },
        [editor, uploadSource],
    );

    return (
        <>
            <button type="button" className={clsx(toolbarStyles.btn)} onMouseDown={onClick} title="Insert image" aria-label="Insert image">
                <ImageRoundedIcon fontSize="small" />
            </button>
            <input ref={inputRef} type="file" accept={ACCEPT} onChange={onFile} style={{ display: 'none' }} />
        </>
    );
}
